import React, {useState} from 'react';
import {useTecRmi} from "../../contexts/TecRmiContext";
import useDidMountEffect from "../../utils/useDidMountEffect";
import apiUser from "../../apiUser";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import appUserRoutes from "../../appUserRoutes";
import {TAB_TIPS} from "../../views/UserViews/TecRmi/MainView";
import {Accordion, AccordionCollapse, AccordionToggle} from "react-bootstrap";
import {Alert, Card, CardBody, CardHeader} from "reactstrap";
import moment from "moment";

const TipsTab = () => {
  const { getApiPrimaryParams, showType, ident } = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [notes, setNotes] = useState([])

  useDidMountEffect(() => {
    setLoading(true)

    apiUser.tecRmi.notes.allInfosForType({
      ...getApiPrimaryParams(),
      includeOutededInfos: false,
    })
      .then(res => setNotes(res.data))
      .finally(() => setLoading(false))
  })

  const classificationMapToColor = (classification) => {
    switch (classification) {
      case 607: return 'danger';
      case 608: return 'warning';
      default: return 'secondary'
    }
  }

  return (
    <React.Fragment>
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tab(ident, TAB_TIPS)}>Wskazówki</BreadcrumbsItem>
      {
        loading
          ? <LoadingSpinner />
          : notes.length > 0
            ? <Accordion>
              {notes.map(note => <Card className="mb-0">
                <CardHeader className="p-0">
                  <AccordionToggle className={`py-2 px-3 cursor-pointer bg-${classificationMapToColor(note.Classification)}`} eventKey={note.InfoId.toString()} as={'div'}>
                    <span>{note.Headline}</span>
                    <span className="ml-2">({moment(note.ValidFrom).format('YYYY-MM-DD')} - {moment(note.ValidTo).format('YYYY-MM-DD')})</span>
                  </AccordionToggle>
                </CardHeader>
                <AccordionCollapse eventKey={note.InfoId.toString()}>
                  <CardBody className="p-3">
                    <div dangerouslySetInnerHTML={{__html: note.Text.replaceAll('\n', "<br />")}} />
                  </CardBody>
                </AccordionCollapse>
              </Card>)}
            </Accordion>
            : <Alert color={'info'} className="text-center">Brak danych</Alert>

      }
    </React.Fragment>
  );
};

TipsTab.propTypes = {

};

export default TipsTab;